module.exports = __webpack_public_path__ + "static/img/12000.10c0c085.png";